import { render, staticRenderFns } from "./DriverDetails.vue?vue&type=template&id=62694376&scoped=true&"
import script from "./DriverDetails.vue?vue&type=script&lang=js&"
export * from "./DriverDetails.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetails.vue?vue&type=style&index=0&id=62694376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62694376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
